import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/database';

var firebaseConfig = {
  apiKey: "AIzaSyCNGXpIWOXQUdSxllZLafEdH6o_4-7Yh9c",
  authDomain: "libras-plus.firebaseapp.com",
  databaseURL: "https://libras-plus-default-rtdb.firebaseio.com",
  projectId: "libras-plus",
  storageBucket: "libras-plus.appspot.com",
  messagingSenderId: "478975492092",
  appId: "1:478975492092:web:490eae037eee24819ebc79",
  measurementId: "G-GCYLSLD07T"
};
// Get a Firestore instance
const app = firebase
  .initializeApp(firebaseConfig);
firebase.analytics();

const firestore = app.firestore();

firestore.enablePersistence();

export const db = firestore;
export const rdb = app.database();

export const storage = firebase.storage(app);

export const auth = app.auth();
